module.exports = __webpack_public_path__ + "img/whole_box4_9.b31bfd55.jpg";